<script>
import { toRef } from "vue";
import { useField } from "vee-validate";

export default {
  name: "FieldNumber",
  inject: [ 'store'],
  emits: ["onEvaluateValueResetter"],
  props: {
    field:{},
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // use `toRef` to create reactive references to `name` prop which is passed to `useField`
    // this is important because vee-validte needs to know if the field name changes
    // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
    const name = toRef(props, "name");

    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(name, undefined, {
      initialValue: props.value,
    });
    return {
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
    };
  },
  data() {
    return {
      isAutoCalc: false,
      resultFromAutoCalc: "",
      numberWithComma: "",
      numberInt: 0
    }
  },
  computed:{
    computedValInt:{
      get(){
        const val = Number(this.store.automaticCalcResult[this.field.id]);
        return val
      },
      set(value){
        const val = Number(value.toString()?.trim()?.replaceAll(',', ''));
        const valInt = isNaN(val) ? 0 : val;
        this.inputValue = valInt;
        this.store.calcModel[this.field.id] = valInt;
        this.store.automaticCalcResult[this.field.id] = valInt;
      }
    }
  },
  updated(){
    if(this.store.automaticCalc[this.field.id]){
      // perform calculation
      const minus = (x, y) => x - y;

      const args = this.store.automaticCalc[this.field.id].args

      let areAllArgsFieldsHaveValue = true;

      const argsValue = args.map(argField => {
        if (this.store.calcModel[argField] == undefined) {
          areAllArgsFieldsHaveValue = false;
        }
        return Number(this.store.calcModel[argField]) || 0
      })

      if (areAllArgsFieldsHaveValue) {
        const automaticCalculationResult = argsValue.reduce(minus)
        const resultField = this.store.automaticCalc[this.field.id].result

        this.store.automaticCalcResult[resultField] = automaticCalculationResult
      }
      
    }
  },
  mounted(){
    if(this.store.automaticCalcResult[this.field.id] ){
      this.isAutoCalc = true;
    }
    
    const displayValue = this.store.comma[this.field.id] || this.field.min_value;
    this.numberWithComma = displayValue;
    this.store.calcModel[this.field.id] = displayValue;

    // handling minimum loan to equal 15000
    // it's a special rule for ideal Auto loan
    if(this.field.id == 'total_loan_amount' ){
      this.store.automaticCalcResult['total_loan_amount'] = 15000
      this.inputValue = 15000
    }

    // console.log(displayValue, this.inputValue);
    
    setTimeout(()=>{
      this.$refs.fieldNum.value = displayValue?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '';
    }, 100)

  },
  unmounted(){
    delete this.store.calcModel[this.field.id];
    this.$emit("onEvaluateValueResetter", this.field)
  },
  methods:{
    handleFocus(e) {
      const value = e.target.value;
      e.target.value = value.replaceAll(',','')
    },
    handleBlur(e) {
      const value = e.target.value;
      e.target.value = value?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.$emit("onEvaluateValueResetter", this.field);
    },
  }
}
</script>

<template>
  <label @click="this.$refs.fieldNum.focus()" class="currency_input">
    <template v-if="field.place_holder">
      <label @click="this.$refs.fieldNum.focus()" class="currency_input__currency">
        {{field.place_holder}}
      </label>
    </template>
    
    <input
      ref="fieldNum"
      :id="name"
      :type="type"
      v-model="computedValInt"
      :required="field.allow_empty == 0 ? true : false"
      :disabled="(field.read_only? true : false) || (field.id == 'total_loan_amount')"
      @focus="handleFocus"
      @blur="handleBlur"
    />
  </label>
</template>